<template>
  <v-container fluid class="pa-0 rounded-xl white customer-form-shell">
    <v-card elevation="0">
      <v-card-text
        class="customer-form-header d-flex align-center justify-space-between flex-wrap">
        <v-container class="pa-0 customer-form-title">
          <div>
            <span v-if="isUpdating">Update Customer</span
            ><span v-else>New Customer</span>
          </div>
        </v-container>

        <v-container class="pa-0 customer-parent-field">
          <v-autocomplete
            rounded
            outlined
            dense
            hide-details
            label="Parent Customer"
            :items="customers"
            item-value="id"
            :item-text="getCustomerName"
            v-model="customer.parentCustomerId"
          ></v-autocomplete>
        </v-container>
      </v-card-text>
      <v-card-text>
        <v-container class="white rounded-xl">
          <v-form ref="form" v-model="isFormValid">
            <v-text-field
              :rules="nameRules"
              label="Full Name"
              v-model="customer.name"
              dense
              rounded
              outlined
              required
            ></v-text-field>
            <v-text-field
              :rules="textRules"
              label="Address 1"
              dense
              rounded
              outlined
              v-model="customer.address1"
              required
            ></v-text-field>
            <v-text-field
              label="Address 2"
              dense
              rounded
              outlined
              v-model="customer.address2"
            ></v-text-field>
            <v-text-field
              label="Email"
              v-model="customer.email"
              dense
              rounded
              outlined
            ></v-text-field>
            <v-text-field
              :rules="phoneRules"
              label="Phone"
              v-model="customer.phone"
              dense
              rounded
              outlined
              required
            ></v-text-field>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="customer-form-actions">
        <v-spacer></v-spacer>
        <v-btn
          v-if="isUpdating"
          color="primary"
          depressed
          rounded
          @click="updateCustomer"
          :loading="isLoading"
          ><i class="fas fa-save mr-2"></i>Update Customer</v-btn
        >
        <v-btn
          v-else
          color="primary"
          depressed
          rounded
          @click="addCustomer"
          :loading="isLoading"
          :disabled="!isFormValid"
          ><i class="fas fa-user-plus mr-2"></i>Add New Customer</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import backendService from "@/services/backend-service";
import generalMixin from "@/js/general-mixin";
import formMixin from "@/js/form-mixin";

export default {
  name: "CustomerForm",
  mixins: [generalMixin, formMixin],
  mounted: function () {},
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isUpdating: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    customer: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    addCustomer() {
      this.isLoading = true;
      backendService
        .addCustomer(this.customer)
        .then((response) => {
          this.$store.commit("addCustomer", response.data);
          this.timer(1000).then(() => {
            this.isLoading = false;
            this.customer = {};
            this.$refs.form.reset();
            this.input = false;
            this.$emit("handle-change");
            this.successSnackbar("Successfully added a new customer");
          });
        })
        .catch(() => {
          this.timer(1000).then(() => {
            this.isLoading = false;
            this.errorSnackbar("Ops! Something is not right");
          });
        });
    },
    getCustomerName(customer) {
      if (!customer) return "";
      if (customer) {
        return `${customer.name} - ${customer.phone}`;
      }
      return "";
    },
    getCustomerById(id) {
      backendService.getCustomerById(id).then((response) => {
        this.customer = response.data;
      });
    },
    updateCustomer() {
      this.isLoading = true;
      backendService
        .updateCustomer(this.customer)
        .then(() => {
          this.$store.commit("updateCustomer", this.customer);
          this.timer(1000).then(() => {
            this.isLoading = false;
            this.$emit("handle-change");
            this.successSnackbar("Successfully updated the customer");
          });
        })
        .catch(() => {
          this.isLoading = false;
          this.errorSnackbar("Ops! Something is not right");
        });
    },
  },
};
</script>
<style scoped>
.customer-form-shell {
  max-width: 720px;
  overflow: hidden;
}
.customer-form-header {
  gap: 16px;
}
.customer-form-title {
  flex: 1 1 180px;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.25;
}
.customer-parent-field {
  flex: 1 1 260px;
}
.customer-form-actions {
  padding: 0 16px 16px;
}
</style>
